import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import pluralize from 'pluralize';

import Badge from '../../../../../../../components/global/Badge';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  count: PropTypes.number,
  totalPhotos: PropTypes.number,
  toAllPhotos: PropTypes.bool,
};

const MembershipsNavigationLink = ({
  id,
  label,
  onClick,
  className,
  count,
  totalPhotos,
  toAllPhotos,
}) => {
  const classes = classNames({
    'membership-nav-link': true,
    [className]: !!className,
  });

  return (
    <Link
      to={`/consumer/matches/${id}${toAllPhotos ? '/all' : ''}`}
      className={classes}
      onClick={onClick}
    >
      <span
        className={classNames({
          'membership-nav-link-label': true,
          'with-count': count != null,
        })}
      >
        {label}
      </span>

      {count != null && (
        <Badge round badgeSize="xs">
          {count}
        </Badge>
      )}
      {typeof totalPhotos !== 'undefined' && totalPhotos > 0 && (
        <div className="membership-nav-link-total-count">
          {pluralize('photo', totalPhotos, true)} uploaded
        </div>
      )}
    </Link>
  );
};

MembershipsNavigationLink.propTypes = propTypes;

export default MembershipsNavigationLink;
